import React from 'react';
import { Modal } from 'antd';
import Template from './templates/Template';

const Preview = ({ visible, onCancel, data, templateType = 1 }) => {
  return (
    <Modal
      title="名片预览"
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={800}
      centered
    >
      <div style={{
        padding: '20px',
        display: 'flex',
        justifyContent: 'center',
      }}>
        <Template data={data} templateType={templateType} />
      </div>
    </Modal>
  );
};

export default Preview; 